<template>
  <img
    v-if="image && image.image && image.image.fields.file"
    :src="image.image.fields.file.url + sizeParams"
    :alt="alt"
    :class="imageClasses"
    :style="maxWidth"
    type="image/jpeg"
  />
</template>

<script>
export default {
  name: "BaseImage",
  props: {
    image: {
      type: Object,
      required: true
    },
    classes: {
      type: String,
      required: false,
      default: ""
    },
    isInline: {
      type: Boolean,
      required: false,
      default: false
    },
    customScale: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    imageClasses() {
      return this.classes
        ? this.classes
        : this.isInline
        ? "inline-block align-middle"
        : "inline-block align-bottom";
    },
    quality() {
      return this.image.quality ? "q=" + this.image.quality : "q=" + "80";
    },
    width() {
      if (this.image.width) {
        return "&w=" + this.image.width;
      } else {
        return "";
      }
    },
    height() {
      return this.image.height ? "&h=" + this.image.height : "";
    },
    sizeParams() {
      return this.customScale
        ? this.customScale
        : "?" + this.quality + this.width + this.height;
    },
    maxWidth() {
      const width =
        this.image.maxWidth && this.image.width
          ? `max-width: ${this.image.maxWidth}px;`
          : this.image.maxWidth
          ? `max-width: ${this.image.maxWidth}px;width: 100%;`
          : "";
      return width;
    },
    alt() {
      return this.image && this.image.alt ? this.image.alt : "picture";
    },
  },
};
</script>
